<div class="container">
  <pdq-heading element="h6">Features</pdq-heading>
  <div class="feature">
    <p>Attach widget to Gorgias ticket with recent customer's orders</p>
    <pdq-slide-toggle
      [disabled]="!integration?.isConnected"
      [defaultValue]="ticketWidgetOn"
      (onToggle)="handleToggle($event, Feature.TICKET)"></pdq-slide-toggle>
  </div>

  <!-- <div class="feature">
    <p>Attach widget to Gorgias ticket with customer's information</p>
    <pdq-slide-toggle
      [disabled]="!integration?.isConnected"
      [defaultValue]="customerWidgetOn"
      (onToggle)="handleToggle($event, Feature.CUSTOMER)"></pdq-slide-toggle>
  </div> -->
</div>
